import {Box, Typography} from "@mui/material";
import Link from "next/link";
import Image from "next/image";
import React from "react";
import {CmPicture, PageGridPlacement as CmPageGridPlacement} from "../../../../packages/graphql-layer/src";
import {useTheme} from "@mui/material/styles";
import useWindowSize from "../../../utility/useWindowSize";

interface Props {
    navigation: any,
    header: CmPageGridPlacement
}

const LOGO_HEIGHT = '44px';
const LOGO_HEIGHT_SMALL_SCREENS = '24px';

function Logo(props: Props) {
    const theme = useTheme();

    // temporary fix: the logos of some facilities are too large for mobile view (SOSHDL-607)
    // @ts-ignore
    const {lowerThanWindowSmall, lowerThanWindowMedium} = useWindowSize()

    const logoStyle = {
        width: 'auto',
        minHeight: LOGO_HEIGHT_SMALL_SCREENS,
        height: lowerThanWindowSmall ? LOGO_HEIGHT_SMALL_SCREENS : LOGO_HEIGHT,
        marginTop: '4px',
        marginLeft: lowerThanWindowMedium ? '8px' : '0px',
        maxWidth: lowerThanWindowSmall ? '175px' :'100%',
    }

    const navigationRoot = props.navigation.content.site.root;
    const logoPicture = props.header && props.header.items ? (props.header.items[0]) as CmPicture : null;

    return <Box sx={{display: 'flex', justifyContent: 'flex-start', flexGrow: 1}}>
        <Link id={"logo"} href={navigationRoot.selfUrl} prefetch={false}>
            {logoPicture
                ? <Image data-cypress={'logoImage'}
                         alt={logoPicture.picture?.alt || ''}
                         src={`/media${logoPicture.picture?.data?.uri}`}
                         priority={true}
                         width={300}
                         height={50}
                         style={logoStyle}
                />
                : <Typography>{navigationRoot.name}</Typography>}
        </Link>
    </Box>

}

export default Logo;